<template>
  <a :href="extUrl ? extUrl : 'javascript:void(0)'" target="_blank" class="bubble">
    <slot></slot>  
  </a>
</template>

<script>
  export default {
    name: 'bubbleText',
    props: {
      external: Boolean,
      extUrl: String
    }
  };
</script>

<style lang='scss' scoped>
  @import './../variables';
  $bubble-radius: 120px;
  $bubble-radius-desktop: 174px;

  .bubble {
    width: $bubble-radius;
    height: $bubble-radius;
    border-radius: $bubble-radius;
    background-size: 15px;
    color: #FFF;
    position: absolute;
    // bottom: 0;
    transform: translateX(-50%);
    font-size: 16px;
    line-height: 19px;
    font-weight: 600;
    top: -40px;
    left: 50%;
    z-index: 1;

    &.no-cursor {
      cursor: default;
    }
    &.dark-blue {
      background-color: $bubly-blue;
      display: none;
    }
    &.light-blue {
      background: $bubly-blue-light url('/static/images/double-arrow.png') 93% 60% no-repeat;
      background-size: 12%;
      display: none;
    }

    span {
      position: absolute;
      top: 50px; 
      width: 100%;
      left: 0;
    }

    @include breakpoint('tablet') {
      &.dark-blue,
      &.light-blue {
        display: block;
      }

    }
  }
  
</style>



// WEBPACK FOOTER //
// src/components/bubbleText.vue